<template>
	<div class="p4">
		<core-form-input
			componentName="j-base-input-long-text"
			:label="$t('cancellation_reason')"
			name="cancellationReason"
			v-model="reason"
			v-validate="'required'"
			:status="errors.first('cancelPolicy') ? 'error' : null"
		/>

		<core-form-input
			:label="this.$t('send_cancellation_email')"
			componentName="j-base-radios"
			name="sendEmailToggle"
			class="mt8"
			v-model="sendEmailToggle"
			v-validate="'required'"
			:options="[
				{ name: $t('yes'), value: 'yes' },
				{ name: $t('no'), value: 'no' }
			]"
		/>

		<j-button class="mt8" @click="cancelPolicy" action="cancelPolicy">{{
			this.$t("cancel_policy")
		}}</j-button>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton/"
import api from "../../api/"

export default {
	components: {
		CoreFormInput,
		JButton
	},
	props: ["id", "contractHolder", "product"],
	data() {
		return {
			reason: null,
			sendEmailToggle: "no"
		}
	},
	computed: {
		env() {
			return this.$store.state.settings.env
		},
		productName() {
			const productPlanMapping = {
				"S00027-01-000-02": "standard",
				"F00038-02-000-02": "flexiPrivate",
				"F00038-01-000-02": "flexiSemiPrivate"
			}
			return productPlanMapping[this.product.productId.plan]
		},
		cancelTemplateEmail() {
			const emailTemplateMapping = {
				standard: "EMAIL_VHIS_STANDARD_CANCELLATION_POLICY",
				flexiPrivate: "EMAIL_VHIS_FLEXI_PRIVATE_CANCELLATION_POLICY",
				flexiSemiPrivate: "EMAIL_VHIS_FLEXI_SEMIPRIVATE_CANCELLATION_POLICY"
			}
			return this.env[emailTemplateMapping[this.productName]]
		}
	},
	methods: {
		initialize() {
			this.reason = this.cancellationReason
		},
		async sendCancellationEmail(emailAddress) {
			const variables = {
				input: {
					type: "cancellation",
					emailMessage: {
						from: this.env.VHIS_EMAIL_FROM,
						to: emailAddress,
						templateRendering: {
							templateId: this.cancelTemplateEmail,
							input: {
								name: "data",
								variablesJsonString: JSON.stringify({
									policyWhere1: {
										id: this.id
									}
								})
							}
						}
					}
				}
			}
			await api.sendNotification(variables)
		},
		async cancelPolicy() {
			const isValid = await this.$validator.validate()
			if (!isValid) return
			this.isCancelPolicyLoading = true
			// Cancel policy and update cancellation reason
			const res = await api.cancelPolicy({
				policyId: this.id,
				reason: this.reason
			})
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}
			// 1. Filter contacts of holder and return those with type === "email"
			// 2. Create a new array with values that pass filter
			// 3. Send cancellation email to each email in array
			const contacts = this.contractHolder.contacts
			if (contacts !== null && this.sendEmailToggle === "yes") {
				const emails = contacts
					.filter(contact => {
						if (contact.type === "email") return contact.value
					})
					.map(item => item.value)
				Promise.all(emails).then(result =>
					result.forEach(item => this.sendCancellationEmail(item))
				)
			}
			// Emit event
			this.$emit("cancelled")
			// Toast Message
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("policy_cancelled")
				}
			})
		}
	},
	mounted() {
		this.initialize()
	}
}
</script>
